import {
    GET_NOTIFICATIONS_SUCCESS,
    GET_UNREAD_NOTIFICATIONS_SUCCESS,
    GET_UNRENDER_NOTIFICATIONS_SUCCESS,
    REMOVE_NOTIFICATIONS,
} from './notification.types';

const initialState = {
    notifications: [],
    unreadNotifications: [],
    unRenderNotifications: 0,
};

export const notificationReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_NOTIFICATIONS_SUCCESS:
            return {
                ...state,
                notifications: action.payload,
            };

        case GET_UNREAD_NOTIFICATIONS_SUCCESS:
            return {
                ...state,
                unreadNotifications: action.payload,
            };

        case REMOVE_NOTIFICATIONS:
            return {
                ...state,
                notifications: [],
            };

        case GET_UNRENDER_NOTIFICATIONS_SUCCESS:
            return {
                ...state,
                unRenderNotifications: action.payload,
            };

        default:
            return state;
    }
};
